import { render, staticRenderFns } from "./QutaEditAppr.vue?vue&type=template&id=573decbe&scoped=true&"
import script from "./QutaEditAppr.vue?vue&type=script&lang=js&"
export * from "./QutaEditAppr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573decbe",
  null
  
)

export default component.exports